import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { fetchUnitDetails } from "actions/Units";
import TabbedSection from "components/TabbedSection";
import LockSettingsInformationModal from "app/routes/Sites/routes/Display/UnitsUsers/LockSettings/LockSettingsInformationModal";
import LockSettingsSettingsModal from "app/routes/Sites/routes/Display/UnitsUsers/LockSettings/LockSettingsSettingsModal";
import LockSettingsMotionSettingsModal from "app/routes/Sites/routes/Display/UnitsUsers/LockSettings/LockSettingsMotionSettingsModal";
import LockSettingsLocationModal from "app/routes/Sites/routes/Display/UnitsUsers/LockSettings/LockSettingsLocationModal";

const LockSettingsModal = ({ lock, unitUUID }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const authUser = useSelector(state => state.auth.authUser);
  const fetchedLock = useSelector(state => state.units.unitObject?.unit?.locks.find(l => l.id === lock.id));

  useEffect(() => {
    dispatch(fetchUnitDetails(unitUUID));
  }, [dispatch, unitUUID]);

  const allTabs = [
    { 
      tab: "Information", 
      label: intl.formatMessage({ id: "pages.settings.info" }), 
      showLabel: true, 
      permission: "manage_locks" 
    },
    { 
      tab: "Settings", 
      label: intl.formatMessage({ id: "pages.settings.Types" }), 
      showLabel: true, 
      permission: "manage_locks" 
    },
    { 
      tab: "Motion Settings", 
      label: intl.formatMessage({ id: "pages.settings.MotionSettings" }), 
      showLabel: true, 
      permission: "manage_locks" 
    },
    { 
      tab: "Location", 
      label: intl.formatMessage({ id: "pages.settings.location" }), 
      showLabel: true, 
      permission: "manage_locks" 
    },
  ];

  const tabs = allTabs.filter(tab => {
    const hasPermission = authUser?.permissions?.includes(tab.permission);
  
    if (tab.tab === "Motion Settings") {
      return hasPermission &&
        (fetchedLock?.bleHwVersion === "1A" && authUser?.featureflagAssignments?.includes("motion_settings")) ||
        (fetchedLock?.bleHwVersion === "1A" && authUser?.featureflagAssignments?.includes("motion_settings_condensed_1A")) ||
        (fetchedLock?.bleHwVersion === "3E" && authUser?.featureflagAssignments?.includes("motion_settings_condensed_3E")) ||
        (fetchedLock?.bleHwVersion === "4E" && authUser?.featureflagAssignments?.includes("motion_settings_condensed_4E"));
    }
  
    return hasPermission;
  });

  const tabComponents = {
    Information: <LockSettingsInformationModal lock={lock} unitUUID={unitUUID} />,
    Settings: <LockSettingsSettingsModal lock={lock} unitUUID={unitUUID} />,
    "Motion Settings": <LockSettingsMotionSettingsModal lock={lock} />,
    Location: <LockSettingsLocationModal lock={lock} unitUUID={unitUUID} />,
  };

  return (
    <TabbedSection topPadding={false} tabs={tabs} defaultTab="Information">
      {tabComponents}
    </TabbedSection>
  )
};

export default LockSettingsModal;